import { Box, Heading, Paragraph, Text } from 'grommet'
import styled from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const BoxWrapper = styled(Box)`
  position: relative;

  & > div:not(:first-child) {
    margin-top: ${({ theme }) => theme.spaces[4]}px;
  }

  ${({ theme }) => theme.below.laptop`
    &>div:not(:first-child) {
      margin-top: ${theme.spaces[2]}px;
    }
    padding: 0px ${theme.spaces[2]}px;
`}
`

export const Content = styled(NormalizedWrapper)`
  max-width: 998px;
`

export const Wrapper = styled(Box)`
  margin-top: ${({ marginTop }) => marginTop};
  position: relative;
  z-index: 3;

  ${({ theme }) => theme.below.laptop`
    margin-top:${theme.spaces[5]}px;
  `}
  .value {
    font-size: ${({ theme }) => theme.fontSizes[14]}px;
    line-height: ${({ theme }) => theme.lineHeight[0]}px;
    margin-top: 23px;
    padding-left: ${({ theme }) => theme.spaces[4]}px;
  }
  .list {
    margin-left: 35px;
  }
  .table-title {
    font-size: ${({ theme }) => theme.fontSizes[4]}px;
    height: ${({ theme }) => theme.spaces[4]}px;
  }
  .image-wrapper {
    margin-right: 22px;
  }
`
export const Title = styled(Heading)`
  align-self: ${({ titlePosition }) => titlePosition};
  font-size: ${({ theme }) => theme.fontSizes[12]}px;
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  line-height: ${({ theme }) => theme.lineHeight[3]}px;
  padding: ${({ padding }) => padding};
  text-transform: none;
  z-index: 3;
  & > span {
    color: ${({ theme }) => theme.colors.primary};
  }
  ${({ theme }) => theme.below.mobileL`
    font-size: ${theme.fontSizes[15]}px;
    line-height: 32px;
  `}
`
export const Subtitle = styled(Paragraph)`
  color: ${({ theme }) => theme.colors.silver};
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[0]}px;
  margin-bottom: ${({ theme }) => theme.spaces[4]}px;
  margin-top: ${({ subtitleMargin }) => subtitleMargin};
  max-width: 657px;
  white-space: pre-wrap;
  width: 100%;
  z-index: 3;
  & > a {
    color: ${({ theme }) => theme.colors.primary};
  }

  & > p {
    font-weight: ${({ theme }) => theme.fontWeight[7]};
  }
  ${({ theme }) => theme.below.laptop`
    margin-top:${theme.spaces[3]}px;
`}
`

export const ListTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.silver};
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[0]}px;
  margin-top: ${({ subtitleMargin }) => subtitleMargin};
  max-width: 657px;
  white-space: pre-wrap;
  width: 100%;
  z-index: 3;
  & > p {
    color: ${({ theme }) => theme.colors.silver};
    font-size: ${({ theme }) => theme.fontSizes[14]}px;
    font-weight: ${({ theme }) => theme.fontWeight[5]};
    line-height: ${({ theme }) => theme.lineHeight[0]}px;
  }
  & > a {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.fontSizes[14]}px;
    font-weight: ${({ theme }) => theme.fontWeight[2]};
    line-height: ${({ theme }) => theme.lineHeight[0]}px;
  }
  ${({ theme }) => theme.below.laptop`
    margin-top:${theme.spaces[3]}px;
`}
`

export const WrapperImage = styled(Box)`
  bottom: ${({ bottom }) => bottom}%;
  left: ${({ left }) => left}%;
  position: ${({ position }) => position};
  right: ${({ right }) => right}%;
  top: ${({ top }) => top}%;
  z-index: ${({ order }) => order};

  img {
    height: auto;
    margin: 0 auto;
    max-width: 100%;
    object-fit: contain;
  }

  ${({ theme }) => theme.below.laptop`
    position: ${({ mobilePosition }) => mobilePosition};
    right: ${({ mobilePosition, right }) =>
      mobilePosition === 'absolute' ? `${right}%` : theme.spaces[0]};
    left: ${({ mobilePosition, left }) =>
      mobilePosition === 'absolute' ? `${left}%` : theme.spaces[0]};
    top: ${({ mobilePosition, top }) =>
      mobilePosition === 'absolute' ? `${top}%` : theme.spaces[0]};
    bottom: ${({ mobilePosition, bottom }) =>
      mobilePosition === 'absolute' ? `${bottom}%` : theme.spaces[0]};
    align-self: center;
    display:${({ show }) => show || 'none'};
    margin-top:${({ mobilePosition }) =>
      mobilePosition === 'relative'
        ? `${theme.spaces[4]}px`
        : `${theme.spaces[0]}px`}
  `}
`
export const HexagonWrapper = styled(Box)`
  position: absolute;
  right: ${({ theme }) => theme.spaces[1] - 2}%;
  top: ${({ location }) => location}%;
  z-index: 3;

  & > svg {
    max-width: 310px;
  }

  & > svg > path.skills-hexagon_svg__empty_hex {
    fill: transparent;
    transition: 0.3s all ease;
  }

  & > svg > path.skills-hexagon_svg__orange_hex {
    fill: ${({ theme }) => theme.colors.primary};
    transition: 0.3s all ease;
  }

  & > svg > path.skills-hexagon_svg__empty_hex:hover {
    stroke-width: 8;
  }

  & > svg > path.skills-hexagon_svg__orange_hex:hover {
    stroke-width: 6;
  }

  ${({ theme }) => theme.below.laptop`
    position: relative;
    margin: auto;
    right: ${theme.spaces[0]};
    top: ${theme.spaces[0]};
  `}
`
